// extracted by mini-css-extract-plugin
module.exports = {"links":"FooterColumn_links__1ja3t","title":"FooterColumn_title__3LQvw","footerLink":"FooterColumn_footerLink__dQcqh"};